import React, {useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import Posts from "../../../components/Posts/Posts";
import * as actions from "../../../store/actions";

const TopPosts = () => {

    const postData = useSelector(state => state.post.posts)
    const loading = useSelector(state => state.post.loading)

    const dispatch = useDispatch()

    const url = "/posts.json"
    // TODO Add queryParams for top posts
    const queryParam = ""
    const getPosts = useCallback(() => dispatch(actions.post(url, queryParam)), [dispatch])

    useEffect(() => {
        getPosts()
        document.title = "Hacker News clone"
    }, [getPosts])

    return (
        <>
            {loading ? "Loading..." : null}
            <Posts postData={postData}/>
        </>
    )

}

export default TopPosts;